import { ScheduleOption } from 'src/app/pages/schedule-register/models/schedule-option-interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const scheduleOptionActions = createEagerSelectActions<ScheduleOption>('[Schedule Options]');
